import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Card, CardContent, Button, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { ChevronRight, Add } from '@mui/icons-material';
import axios from 'axios';

const AmplifiedEvents = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/amplified-events');
        setEvents(response.data);
      } catch (error) {
        console.error('Error fetching national events:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Button
          variant="contained"
          sx={{
            mb: 4,
            bgcolor: '#6200ee',
            borderRadius: 2,
            py: 1.5,
            px: 3,
            textTransform: 'none',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            '&:hover': { bgcolor: '#3700b3' },
          }}
          startIcon={<Add />}
          onClick={() => navigate('/publish-amplified-event')}
        >
          Publish National Event
        </Button>

        {events.length === 0 ? (
          <Typography sx={{ textAlign: 'center', color: '#666', mt: 8, fontSize: '1rem' }}>
            No national events published yet
          </Typography>
        ) : (
          events.map(event => (
            <Card
              key={event._id}
              sx={{
                mb: 2,
                bgcolor: '#fff',
                borderRadius: 2,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/teacher/amplified-event-details', { state: { event } })}
            >
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 1 }}>
                  {event.eventName}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
                  {new Date(event.dateTime).toLocaleDateString()}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666' }}>
                  {event.venue}
                </Typography>
                <ChevronRight sx={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', color: '#6200ee' }} />
              </CardContent>
            </Card>
          ))
        )}
      </motion.div>
    </Container>
  );
};

export default AmplifiedEvents;